import React from 'react';
import MDProgress from 'react-md-progress-bar';
import MDSpinner from 'react-md-spinner';
import Pagination from 'react-js-pagination';
import PropTypes from 'prop-types';
import {Button, ButtonGroup, Table} from 'reactstrap';
import classnames from 'classnames';
import NumberLabel from "../NumberLabel/NumberLabel";

class ListComponent extends React.Component{

    static propTypes = {
        getItems: PropTypes.func,
        getItemsPaginated: PropTypes.func,
        loadingMessage: PropTypes.string,
        noRowsFilterMessage: PropTypes.string,
        rowActions: PropTypes.array,
        onRowClick: PropTypes.func,
        columns: PropTypes.array,
        striped: PropTypes.bool,
        hover: PropTypes.bool,
        responsive: PropTypes.bool,
        paginate: PropTypes.bool,
        getRowClass: PropTypes.func,
        defaultRowClass: PropTypes.string,
        noRowsMessage: PropTypes.any,
        pageSizes: PropTypes.array,
        sessionKey: PropTypes.string,
        filterItem: PropTypes.func,
        stateKey: PropTypes.string,
        page: PropTypes.number,
        limit: PropTypes.number,
        onPaginationChange: PropTypes.func,
        minHeight: PropTypes.number,
        tableRender: PropTypes.func,
        canLoadItems: PropTypes.func,
        formatValue: PropTypes.func
    };

    constructor(props){
        super(props);

        this.state = {
            items: null,
            itemsFiltered: null,
            totalItems: 0,
            isBusy: false,
            isLoaded: false,
            error: null
        };

        this._isMounted = false;
        this.refresh = this.refresh.bind(this);

    }

    setStateSafe(state,callback){

        if(this._isMounted){
            this.setState(state,callback);
        }

    }


    async componentDidMount(){

        this._isMounted = true;

        //  Load items
        await this.loadItems();
    }


    async loadItems(page,limit){

        //
        if(this.props.canLoadItems){

            if(await this.props.canLoadItems(page,limit) !== true)
                return;

        }

        //  already busy??
        if(this.state.isBusy) {
            return;
        }

        this.setStateSafe({
            isBusy: true,
            error: null
        });


        let payload;

        try{

            if (this.props.paginate) {

                const context = {
                    page: page || this.props.page,
                    limit: limit || this.props.limit
                };

                payload = await this.props.getItemsPaginated(context);
            }
            else {

                payload = await this.props.getItems();
                if(!payload.hasOwnProperty('totalItems') && payload.hasOwnProperty('items')){
                    payload.totalItems = payload.items.length;
                }

            }

        }
        catch (e) {

            payload = {
                error: e
            };
        }


        this.setStateSafe({
            items: payload.hasOwnProperty('items') ? payload.items : this.state.items,
            totalItems: payload.hasOwnProperty('totalItems') ? payload.totalItems : this.state.totalItems,
            error: payload.error,
            isLoaded: payload.hasOwnProperty('items') && !payload.hasOwnProperty('error')
        });


        this.setStateSafe({
            isBusy: false
        });

    }

    refresh(){
        return this.loadItems();
    }

    /**
     * Determines the component is busy
     * @return {boolean}
     */
    isBusy(){
        return this.state.isBusy;
    }

    /**
     * Checks the component is empty
     * @return {null|boolean}
     */
    isEmpty(){
        return this.state.items && this.state.items.length === 0;
    }

    /**
     * Gets visible columns
     * @return {Array.<*>|T[]}
     */
    getVisibleColumns(){
        return (this.props.columns || []).filter(x => x.hasOwnProperty('isVisible') ? (typeof x.isVisible === "function" ? x.isVisible() : x.isVisible) : true );
    }

    renderTableDefault(content){

        const props = this.props;
        const columns = this.getVisibleColumns();
        const rowActions = props.rowActions || [];

        return <Table  striped={props.striped} responsive={props.responsive} hover={props.hover}>

            <thead>
            <tr>
                {columns.map((c,key) =>{
                    return (<th key={key}>{c.label}</th>)
                })}
                {rowActions.length > 0 && <th/>}
            </tr>
            </thead>

            {content && <tbody>
            {content}
            </tbody>}

        </Table>
    }

    render(){

        const props = this.props;
        const state = this.state;
        const rowActions = props.rowActions || [];
        const items = state.items || [];
        const columns = this.getVisibleColumns();
        const { error } = this.state;

        return <div style={{ minHeight: props.minHeight  }}>
            {(state.isBusy && !state.isLoaded) ? (<div className="text-center" style={{ marginTop: 40 }}>
                    <MDSpinner size={45}/>
                    <p style={{marginTop: 35}}>{props.loadingMessage}</p>
                </div>):
                <div style={{ marginTop: 40 }}>

                    {((state.items && state.totalItems > 0) || (!error && !state.isLoaded && props.tableRender) ) ? (props.tableRender ? props.tableRender({ props , data: items }): this.renderTableDefault(items.map((prop, key) => {

                            const item = state.items[key];
                            return <tr key={key} className={ classnames(props.getRowClass ? props.getRowClass(item,key) : null , props.defaultRowClass) } onClick={evt => {

                                if(props.onRowClick){
                                    props.onRowClick(item,key);
                                }

                            }}>

                                {columns.map((column,index) => {
                                    return <td key={index}>{typeof column.render === "function" ? column.render(item,column.key,(this.props.page - 1) * this.props.limit + key ) : ( this.props.formatValue ? this.props.formatValue(item[column.key] , column.format,item) : item[column.key] )  }</td>
                                })}

                                {rowActions.length > 0 && <td className="td-actions">
                                    <ButtonGroup>
                                        {rowActions.map((action,k) => {

                                            return action.component ? <span key={k}>{(typeof action.component === "function" ? action.component(item,key) : action.component )} </span>: <Button key={k}
                                                                                                                                                                                                 style={action.style}
                                                                                                                                                                                                 color={action.color || "link"}
                                                                                                                                                                                                 disabled={typeof action.disabled  === "function" ? action.disabled(item) : action.disabled }
                                                                                                                                                                                                 onClick={() => {

                                                if(action.onClick){
                                                    action.onClick(item,key);
                                                }

                                            }}>{action.icon} {action.label}</Button>

                                        })}
                                    </ButtonGroup>
                                </td>}

                            </tr>

                        }))) :

                        (state.isLoaded ? <div className="text-center">

                                {typeof props.noRowsMessage === "function" ? props.noRowsMessage({ refresh : this.refresh }) : <div>
                                    {this.renderTableDefault()}
                                    <p style={{ marginTop: 10 }} className="text-center">{props.noRowsMessage}</p>

                                    <Button disabled={this.state.isBusy} color="primary" style={{ marginTop: 10  }} onClick={() =>{
                                        this.refresh();
                                    }}><i className="fa fa-refresh"></i> Refresh</Button>

                                </div>}


                            </div> :
                            <div className="text-center" style={{ padding: 50 }}>
                                <span className="text-danger"> <i className="fa fa-exclamation-triangle fa-5x"></i></span>
                                <p style={{ marginTop: 10 }}>{error}</p>
                                <Button color="danger" style={{ marginTop: 10  }} onClick={() => this.refresh()}><i className="fa fa-refresh"></i> Try Again</Button>
                            </div>)

                    }

                    {state.isBusy && <MDProgress overlay={true} show={true}/>}

                    {this.props.paginate && state.totalItems > 0 && <div>
                        <hr/>
                        <div className="clearfix" style={{ marginTop: 20 , marginBottom: 16 }}>
                            <div className="pull-left" style={{ marginLeft: 30 , marginTop: 10}}>
                                Showing page <b><NumberLabel value={this.props.page}/></b> of <b><NumberLabel value={Math.ceil(state.totalItems / this.props.limit)}/></b> - <b>{state.totalItems}</b>
                            </div>

                            <div className="pull-right" style={{marginRight: 30}}>
                                <Pagination    activePage={this.props.page}
                                               itemsCountPerPage={this.props.limit}
                                               totalItemsCount={state.totalItems}
                                               pageRangeDisplayed={5}
                                               hideDisabled={true}
                                               onChange={page => {

                                                   if(this.props.onPaginationChange){
                                                       this.props.onPaginationChange(page,this.props.limit);
                                                   }

                                               }}/>
                            </div>
                        </div>
                    </div>}

                </div>}
        </div>
    }

}

export default ListComponent;


// WEBPACK FOOTER //
// ./src/components/TableListView/ListComponent.js